import { render, staticRenderFns } from "./ConfigurationNavbar.vue?vue&type=template&id=6b35a203&"
import script from "./ConfigurationNavbar.vue?vue&type=script&lang=js&"
export * from "./ConfigurationNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports